<template>
    <div>
        <vs-row>
            <vs-col sm="12" lg="4" class="widthCard" v-if="users && users.alumnosTotal">
                <md-card class="text-center md-info" md-with-hover>
                    <md-ripple>
                        <md-card-header>
                        <div class="md-title">{{users.alumnosTotal}}</div>
                        <div class="md-subhead">ALUMNOS TOTALES</div>
                        </md-card-header>
                    </md-ripple>
                </md-card>
            </vs-col>
            <vs-col sm="12" lg="4" class="widthCard" v-if="users && users.montoTotal">
                <md-card class="text-center md-success" md-with-hover>
                    <md-ripple>
                        <md-card-header>
                        <div class="md-title">{{users.montoTotal | currency}}</div>
                        <div class="md-subhead">MONTO TOTAL</div>
                        </md-card-header>
                    </md-ripple>
                </md-card>
            </vs-col>
            <vs-col sm="12" lg="4" class="widthCard" v-if="users && users.movimientosTotal">
                <md-card class="text-center md-primary" md-with-hover>
                    <md-ripple>
                        <md-card-header>
                        <div class="md-title">{{users.movimientosTotal}}</div>
                        <div class="md-subhead">MOVIMIENTOS TOTALES</div>
                        </md-card-header>
                    </md-ripple>
                </md-card>
            </vs-col>
        </vs-row>
    </div>
</template>

<script>
export default {
    props:[
        'users'
    ]
}
</script>

<style scoped>
.md-success{
    background: #5cb85c;
    color: white;
    border-radius: 7px;
}
.md-primary{
    background: #5bc0de;
    color: white;
    border-radius: 7px;
}
.md-info{
    background: purple !important;
    color: white !important;
    border-radius: 7px;
}
</style>